import React from 'react'
import PropTypes from 'prop-types'
import Link, { LINK_SIZES } from 'components/Link'
import './NoContent.scss'

const NoContent = ({
    heading,
    message,
    link
}) => (
    <div className="no-content">
        <div className="no-content__container">
            {heading && <h2 className="no-content__heading">{heading}</h2>}
            {message && <p className="no-content__message">{message}</p>}
            {link && (
                <div className="no-content__link-holder">
                    <Link
                        {...link}
                        size={LINK_SIZES.large}
                    />
                </div>
            )}
        </div>
    </div>
)

NoContent.propTypes = {
    heading: PropTypes.string,
    message: PropTypes.string,
    link: PropTypes.exact(Link.propTypes),
}

export default NoContent
